import { render, staticRenderFns } from "./editarAtividadeDialog.vue?vue&type=template&id=713feac8"
import script from "./editarAtividadeDialog.vue?vue&type=script&lang=js"
export * from "./editarAtividadeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports